import { Container, Flex } from '@stoplight/mosaic'
import { NonIdealState } from '@stoplight/elements-core'
import { MarkdownViewer } from '@stoplight/markdown-viewer'

import { ContentLoader } from '../components/ContentLoader'
import { MarkdownViewerProvider } from '../components/markdown/MarkdownViewerProvider'

type ArticleProps = {
  isFetched: boolean
  isLoading: boolean
  error: unknown
  data?: string | null
}

export function Article({
  isLoading = true,
  isFetched = false,
  data,
  error,
}: ArticleProps) {
  return (
    <>
      {!isLoading && error && (
        <Flex justify="center" alignItems="center" w="full" h="full">
          <NonIdealState title="Failed to load article" />
        </Flex>
      )}
      <MarkdownViewerProvider>
        {!isFetched ? (
          <Container bg="canvas" size="lg" mt={6}>
            <Flex flexDirection="col" bg="canvas" w="full" alignItems="center">
              <ContentLoader />
            </Flex>
          </Container>
        ) : (
          <>{!error && data && <MarkdownViewer markdown={data} />}</>
        )}
      </MarkdownViewerProvider>
    </>
  )
}
